[
	[
		"NS27-CC33-TE20",
		0,
		0,
		238,
		40
	],
	[
		"EW16-NE3-TE17",
		238,
		0,
		229,
		40
	],
	[
		"NS24-NE6-CC1",
		467,
		0,
		214,
		40
	],
	[
		"EW21-CC22",
		681,
		0,
		168,
		40
	],
	[
		"NS25-EW13",
		0,
		40,
		167,
		40
	],
	[
		"NS26-EW14",
		167,
		40,
		167,
		40
	],
	[
		"EW12-DT14",
		334,
		40,
		166,
		40
	],
	[
		"NE12-CC13",
		500,
		40,
		163,
		40
	],
	[
		"NS17-CC15",
		663,
		40,
		163,
		40
	],
	[
		"CC10-DT26",
		0,
		80,
		162,
		40
	],
	[
		"CC34-DT16",
		162,
		80,
		162,
		40
	],
	[
		"NS21-DT11",
		324,
		80,
		159,
		40
	],
	[
		"NS22-TE14",
		483,
		80,
		159,
		40
	],
	[
		"DT10-TE11",
		642,
		80,
		156,
		40
	],
	[
		"NS1-EW24",
		0,
		120,
		154,
		40
	],
	[
		"EW2-DT32",
		0,
		160,
		152,
		40
	],
	[
		"DT35-CG1",
		0,
		200,
		150,
		40
	],
	[
		"NE1-CC29",
		0,
		240,
		150,
		40
	],
	[
		"CC4-DT15",
		0,
		280,
		148,
		40
	],
	[
		"CC19-DT9",
		0,
		320,
		148,
		40
	],
	[
		"CC17-TE9",
		0,
		360,
		147,
		40
	],
	[
		"NE4-DT19",
		0,
		400,
		147,
		40
	],
	[
		"NE7-DT12",
		0,
		440,
		147,
		40
	],
	[
		"NE16-STC",
		0,
		480,
		147,
		40
	],
	[
		"NE17-PTC",
		0,
		520,
		147,
		40
	],
	[
		"EW8-CC9",
		0,
		560,
		142,
		40
	],
	[
		"NS4-BP1",
		0,
		600,
		135,
		40
	],
	[
		"DT1-BP6",
		0,
		640,
		133,
		40
	],
	[
		"NS9-TE2",
		0,
		680,
		132,
		40
	],
	[
		"EW4-CG",
		0,
		720,
		127,
		40
	],
	[
		"EW10",
		0,
		760,
		90,
		40
	],
	[
		"EW15",
		0,
		800,
		90,
		40
	],
	[
		"EW17",
		154,
		120,
		90,
		40
	],
	[
		"EW18",
		244,
		120,
		90,
		40
	],
	[
		"EW19",
		334,
		120,
		90,
		40
	],
	[
		"EW20",
		424,
		120,
		90,
		40
	],
	[
		"EW22",
		514,
		120,
		90,
		40
	],
	[
		"EW23",
		604,
		120,
		90,
		40
	],
	[
		"EW26",
		694,
		120,
		90,
		40
	],
	[
		"EW25",
		154,
		160,
		90,
		40
	],
	[
		"EW27",
		244,
		160,
		90,
		40
	],
	[
		"EW28",
		334,
		160,
		90,
		40
	],
	[
		"EW29",
		424,
		160,
		90,
		40
	],
	[
		"EW30",
		514,
		160,
		90,
		40
	],
	[
		"EW31",
		604,
		160,
		90,
		40
	],
	[
		"EW32",
		694,
		160,
		90,
		40
	],
	[
		"EW33",
		154,
		200,
		90,
		40
	],
	[
		"EW11",
		244,
		200,
		88,
		40
	],
	[
		"CC12",
		332,
		200,
		86,
		40
	],
	[
		"CC14",
		418,
		200,
		86,
		40
	],
	[
		"CC20",
		504,
		200,
		86,
		40
	],
	[
		"CC16",
		590,
		200,
		86,
		40
	],
	[
		"CC21",
		676,
		200,
		86,
		40
	],
	[
		"CC23",
		762,
		200,
		86,
		40
	],
	[
		"CC24",
		154,
		240,
		86,
		40
	],
	[
		"CC25",
		154,
		280,
		86,
		40
	],
	[
		"CC26",
		154,
		320,
		86,
		40
	],
	[
		"CC27",
		154,
		360,
		86,
		40
	],
	[
		"CC28",
		154,
		400,
		86,
		40
	],
	[
		"CC30",
		154,
		440,
		86,
		40
	],
	[
		"CC31",
		154,
		480,
		86,
		40
	],
	[
		"CC32",
		154,
		520,
		86,
		40
	],
	[
		"BP10",
		154,
		560,
		84,
		40
	],
	[
		"BP12",
		154,
		600,
		84,
		40
	],
	[
		"BP13",
		154,
		640,
		84,
		40
	],
	[
		"CC11",
		154,
		680,
		84,
		40
	],
	[
		"NE10",
		154,
		720,
		84,
		40
	],
	[
		"NE13",
		154,
		760,
		84,
		40
	],
	[
		"NE14",
		154,
		800,
		84,
		40
	],
	[
		"NE15",
		240,
		240,
		84,
		40
	],
	[
		"NE18",
		324,
		240,
		84,
		40
	],
	[
		"NS10",
		408,
		240,
		84,
		40
	],
	[
		"NS12",
		492,
		240,
		84,
		40
	],
	[
		"NS13",
		576,
		240,
		84,
		40
	],
	[
		"NS14",
		660,
		240,
		84,
		40
	],
	[
		"NS15",
		744,
		240,
		84,
		40
	],
	[
		"NS16",
		240,
		280,
		84,
		40
	],
	[
		"NS18",
		324,
		280,
		84,
		40
	],
	[
		"NS19",
		408,
		280,
		84,
		40
	],
	[
		"NS20",
		492,
		280,
		84,
		40
	],
	[
		"NS23",
		576,
		280,
		84,
		40
	],
	[
		"NS28",
		660,
		280,
		84,
		40
	],
	[
		"BP11",
		744,
		280,
		83,
		40
	],
	[
		"DT13",
		240,
		320,
		83,
		40
	],
	[
		"DT17",
		240,
		360,
		83,
		40
	],
	[
		"DT18",
		240,
		400,
		83,
		40
	],
	[
		"DT20",
		240,
		440,
		83,
		40
	],
	[
		"DT21",
		240,
		480,
		83,
		40
	],
	[
		"DT22",
		240,
		520,
		83,
		40
	],
	[
		"DT23",
		240,
		560,
		83,
		40
	],
	[
		"DT24",
		240,
		600,
		83,
		40
	],
	[
		"DT25",
		240,
		640,
		83,
		40
	],
	[
		"DT27",
		240,
		680,
		83,
		40
	],
	[
		"DT28",
		240,
		720,
		83,
		40
	],
	[
		"DT29",
		240,
		760,
		83,
		40
	],
	[
		"DT30",
		240,
		800,
		83,
		40
	],
	[
		"DT31",
		323,
		320,
		83,
		40
	],
	[
		"DT33",
		406,
		320,
		83,
		40
	],
	[
		"DT34",
		489,
		320,
		83,
		40
	],
	[
		"NE11",
		572,
		320,
		83,
		40
	],
	[
		"NS11",
		655,
		320,
		83,
		40
	],
	[
		"TE12",
		738,
		320,
		82,
		40
	],
	[
		"TE13",
		323,
		360,
		82,
		40
	],
	[
		"TE15",
		405,
		360,
		82,
		40
	],
	[
		"TE16",
		487,
		360,
		82,
		40
	],
	[
		"TE18",
		569,
		360,
		82,
		40
	],
	[
		"TE19",
		651,
		360,
		82,
		40
	],
	[
		"TE22",
		733,
		360,
		82,
		40
	],
	[
		"TE23",
		323,
		400,
		82,
		40
	],
	[
		"TE24",
		323,
		440,
		82,
		40
	],
	[
		"TE25",
		323,
		480,
		82,
		40
	],
	[
		"TE26",
		323,
		520,
		82,
		40
	],
	[
		"TE27",
		323,
		560,
		82,
		40
	],
	[
		"TE28",
		323,
		600,
		82,
		40
	],
	[
		"TE29",
		323,
		640,
		82,
		40
	],
	[
		"EW1",
		323,
		680,
		76,
		40
	],
	[
		"EW3",
		323,
		720,
		76,
		40
	],
	[
		"EW5",
		323,
		760,
		76,
		40
	],
	[
		"EW6",
		323,
		800,
		76,
		40
	],
	[
		"EW7",
		405,
		400,
		76,
		40
	],
	[
		"EW9",
		481,
		400,
		76,
		40
	],
	[
		"PW1",
		557,
		400,
		76,
		40
	],
	[
		"PW2",
		633,
		400,
		76,
		40
	],
	[
		"PW3",
		709,
		400,
		76,
		40
	],
	[
		"PW4",
		405,
		440,
		76,
		40
	],
	[
		"PW5",
		481,
		440,
		76,
		40
	],
	[
		"PW6",
		557,
		440,
		76,
		40
	],
	[
		"PW7",
		633,
		440,
		76,
		40
	],
	[
		"SW1",
		709,
		440,
		76,
		40
	],
	[
		"SW2",
		405,
		480,
		76,
		40
	],
	[
		"SW3",
		405,
		520,
		76,
		40
	],
	[
		"SW4",
		405,
		560,
		76,
		40
	],
	[
		"SW5",
		405,
		600,
		76,
		40
	],
	[
		"SW6",
		405,
		640,
		76,
		40
	],
	[
		"SW7",
		405,
		680,
		76,
		40
	],
	[
		"SW8",
		405,
		720,
		76,
		40
	],
	[
		"CG2",
		405,
		760,
		74,
		40
	],
	[
		"CC3",
		405,
		800,
		72,
		40
	],
	[
		"CC2",
		481,
		480,
		72,
		40
	],
	[
		"CC5",
		553,
		480,
		72,
		40
	],
	[
		"CC7",
		625,
		480,
		72,
		40
	],
	[
		"CC6",
		697,
		480,
		72,
		40
	],
	[
		"CC8",
		769,
		480,
		72,
		40
	],
	[
		"BP2",
		481,
		520,
		71,
		40
	],
	[
		"BP3",
		481,
		560,
		71,
		40
	],
	[
		"BP4",
		481,
		600,
		71,
		40
	],
	[
		"BP5",
		481,
		640,
		71,
		40
	],
	[
		"BP7",
		481,
		680,
		71,
		40
	],
	[
		"BP8",
		481,
		720,
		71,
		40
	],
	[
		"BP9",
		481,
		760,
		71,
		40
	],
	[
		"NE5",
		481,
		800,
		71,
		40
	],
	[
		"NE8",
		552,
		520,
		71,
		40
	],
	[
		"NE9",
		623,
		520,
		71,
		40
	],
	[
		"NS2",
		694,
		520,
		71,
		40
	],
	[
		"NS3",
		765,
		520,
		71,
		40
	],
	[
		"NS5",
		552,
		560,
		71,
		40
	],
	[
		"NS7",
		623,
		560,
		71,
		40
	],
	[
		"NS8",
		694,
		560,
		71,
		40
	],
	[
		"DT2",
		765,
		560,
		70,
		40
	],
	[
		"DT3",
		552,
		600,
		70,
		40
	],
	[
		"DT4",
		552,
		640,
		70,
		40
	],
	[
		"DT5",
		552,
		680,
		70,
		40
	],
	[
		"DT6",
		552,
		720,
		70,
		40
	],
	[
		"DT7",
		552,
		760,
		70,
		40
	],
	[
		"DT8",
		552,
		800,
		70,
		40
	],
	[
		"PE1",
		622,
		600,
		70,
		40
	],
	[
		"PE2",
		692,
		600,
		70,
		40
	],
	[
		"PE3",
		762,
		600,
		70,
		40
	],
	[
		"PE4",
		622,
		640,
		70,
		40
	],
	[
		"PE5",
		692,
		640,
		70,
		40
	],
	[
		"PE6",
		762,
		640,
		70,
		40
	],
	[
		"PE7",
		622,
		680,
		70,
		40
	],
	[
		"SE1",
		622,
		720,
		70,
		40
	],
	[
		"SE2",
		622,
		760,
		70,
		40
	],
	[
		"SE3",
		622,
		800,
		70,
		40
	],
	[
		"SE4",
		692,
		680,
		70,
		40
	],
	[
		"SE5",
		762,
		680,
		70,
		40
	],
	[
		"TE1",
		784,
		120,
		68,
		40
	],
	[
		"TE3",
		784,
		160,
		68,
		40
	],
	[
		"TE4",
		692,
		720,
		68,
		40
	],
	[
		"TE5",
		760,
		720,
		68,
		40
	],
	[
		"TE6",
		692,
		760,
		68,
		40
	],
	[
		"TE7",
		692,
		800,
		68,
		40
	],
	[
		"TE8",
		760,
		760,
		68,
		40
	],
	[
		"green-purple-brown",
		798,
		80,
		50,
		16
	],
	[
		"red-purple-yellow",
		798,
		96,
		50,
		16
	],
	[
		"red-yellow-brown",
		90,
		760,
		50,
		16
	],
	[
		"blue-brown",
		90,
		776,
		36,
		16
	],
	[
		"blue-gray",
		90,
		792,
		36,
		16
	],
	[
		"blue-green",
		90,
		808,
		36,
		16
	],
	[
		"green-blue",
		90,
		824,
		36,
		16
	],
	[
		"green-green",
		815,
		360,
		36,
		16
	],
	[
		"green-yellow",
		815,
		376,
		36,
		16
	],
	[
		"purple-blue",
		785,
		400,
		36,
		16
	],
	[
		"purple-gray",
		785,
		416,
		36,
		16
	],
	[
		"purple-yellow",
		785,
		440,
		36,
		16
	],
	[
		"red-blue",
		785,
		456,
		36,
		16
	],
	[
		"red-brown",
		760,
		800,
		36,
		16
	],
	[
		"red-gray",
		760,
		816,
		36,
		16
	],
	[
		"red-green",
		760,
		832,
		36,
		16
	],
	[
		"red-yellow",
		796,
		800,
		36,
		16
	],
	[
		"yellow-blue",
		796,
		816,
		36,
		16
	],
	[
		"yellow-brown",
		796,
		832,
		36,
		16
	],
	[
		"blue",
		826,
		40,
		21,
		16
	],
	[
		"brown",
		826,
		56,
		21,
		16
	],
	[
		"gray",
		133,
		640,
		21,
		16
	],
	[
		"green",
		133,
		656,
		21,
		16
	],
	[
		"purple",
		132,
		680,
		21,
		16
	],
	[
		"red",
		132,
		696,
		21,
		16
	],
	[
		"yellow",
		127,
		720,
		21,
		16
	]
]